import { UnifiedSearchFilters } from "@/Contracts/Products/UnifiedSearch";

export interface SourceFilterCompatibility {
	showManufacturers: boolean;
	showIcecatCategories: boolean;
	showOtherCategories: boolean;
	showProductTypes: boolean;
	showSuppliers: boolean;
	showSyncSource: boolean;
	showLimitDistributors: boolean;
	showExcludeOutOfStock: boolean;
	showExcludeDropshipWH: boolean;
}

export const getSourceFilterCompatibility = (
	sourceTypes: string[]
): SourceFilterCompatibility => {
	const hasIcecat = sourceTypes.includes("icecat");
	const hasSelfCatalog = sourceTypes.includes("self_catalog");
	const hasCustomDistributor = sourceTypes.includes("custom_distributor");
	const hasDickerData = sourceTypes.includes("dicker_data");

	return {
		showManufacturers: hasIcecat || hasSelfCatalog,
		showIcecatCategories: hasIcecat,
		showOtherCategories: hasSelfCatalog,
		showProductTypes: hasSelfCatalog,
		showSuppliers: hasIcecat || hasSelfCatalog || hasCustomDistributor,
		showSyncSource: hasSelfCatalog,
		showLimitDistributors: hasIcecat,
		showExcludeOutOfStock:
			hasIcecat || hasCustomDistributor || hasDickerData,
		showExcludeDropshipWH: hasIcecat
	};
};

export const createDefaultFiltersForSource = (
	sourceTypes: string[],
	isDefaultMode: boolean = true
): UnifiedSearchFilters => {
	let shouldEnableConnectedDistributorsFilter = false;

	if (!isDefaultMode) {
		const isGlobalSource = sourceTypes.includes("self_catalog");
		const isAllSources =
			sourceTypes.length >= 3 &&
			sourceTypes.includes("icecat") &&
			sourceTypes.includes("self_catalog");
		shouldEnableConnectedDistributorsFilter =
			isGlobalSource || isAllSources;
	}

	return {
		source_types: sourceTypes,
		manufacturers: [],
		categories: [],
		icecat_category_ids: [],
		supplier_ids: [],
		exclude_out_of_stock: false,
		filter_by_connected_distributors:
			shouldEnableConnectedDistributorsFilter,
		exclude_drop_ship_wh: false,
		item_types: [],
		sync_sources: []
	};
};

export const getAllAvailableSourceTypes = (
	isDickerDataEnabled: boolean = false
): string[] => {
	const baseSourceTypes = ["icecat", "self_catalog", "custom_distributor"];
	return isDickerDataEnabled
		? [...baseSourceTypes, "dicker_data"]
		: baseSourceTypes;
};
